import React, { useEffect, useState } from 'react'
import { Form, FormikProvider, useFormik } from 'formik'
import PropTypes from 'prop-types'
import { Button, Col, Container, FormGroup, Label, Row } from 'reactstrap'
import { Drawer, InputField, ToggleField } from 'components'
import cmsStoryGroupFormScheme from './cms-story-group-form-scheme'
import initialValues from './cms-story-group-initial-value'
import CmsMediaSidebar from 'domains/cms-media/cms-media-sidebar'
import CmsStoryFieldArray from 'domains/cms-story-group/form/cms-story-field-array'


const OPEN_BY_CONST = {
  STORY_GROUP : 'story_group',
  STORY       : 'story'
}

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  }),
  onSubmit      : PropTypes.func,
  cmsStoryGroup : PropTypes.object,
  isSubmitted   : PropTypes.bool
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  },
  onSubmit    : () => { },
  cmsStory    : {},
  isSubmitted : false
}

const CmsStoryGroupForm = ({
  pageUtils,
  onSubmit,
  cmsStoryGroup,
  isSubmitted
}) => {
  const [ isCmsMediaDrawerOpen, setIsCmsMediaDrawer ] = useState(false)
  const [ selectedThumbnail, setSelectedThumbnail ]   = useState({})
  const [ selectedCmsStory, setSelectedCmsStory ]     = useState([])
  const [ drawerOpenBy, setDrawerOpenBy ]             = useState(OPEN_BY_CONST.STORY_GROUP)
  const [ cmsStoryIndex, setCmsStoryIndex ]           = useState()


  useEffect(() => {
    const cmsStoryGroupExist = Object.keys(cmsStoryGroup).length > 0
    if (!cmsStoryGroupExist) {
      setSelectedThumbnail({})
      setSelectedCmsStory({})
    }
  }, [ isSubmitted, cmsStoryGroup ])

  useEffect(() => {
    if (Object.keys(cmsStoryGroup).length > 0) {
      const cmsStoriesList = cmsStoryGroup?.stories.map(
        ({ cms_media }) => ({ url: cms_media.url, id: cms_media.id })
      )
      const cmsStory       = Object.assign({}, cmsStoriesList)

      setSelectedThumbnail(cmsStoryGroup.thumbnail_cms_image)
      setSelectedCmsStory(cmsStory)
    }
  }, [ cmsStoryGroup ])

  const formik = useFormik({
    initialValues      : initialValues(cmsStoryGroup),
    enableReinitialize : true,
    validationSchema   : cmsStoryGroupFormScheme,
    onSubmit           : onSubmit
  })

  const isThumbnailSelected = Object.keys(selectedThumbnail).length > 0

  const openDrawer = (openBy, index) => {
    setIsCmsMediaDrawer(!isCmsMediaDrawerOpen)
    setDrawerOpenBy(openBy)
    if (index !== undefined) setCmsStoryIndex(index)
  }

  const handleClickCmsMediaSidebar = (media) => {
    if (drawerOpenBy === OPEN_BY_CONST.STORY_GROUP) {
      setSelectedThumbnail(media)
      formik.setFieldValue('thumbnail_cms_image_id', media.id)
    } else {
      setSelectedCmsStory({ ...selectedCmsStory, [ cmsStoryIndex ]: media })
      formik.setFieldValue(`stories.${cmsStoryIndex}.cms_media_id`, media.id)
    }
    setIsCmsMediaDrawer(!isCmsMediaDrawerOpen)
  }

  const handleRemoveImage = (index) => {
    if (typeof index === 'number') {
      setSelectedCmsStory({ ...selectedCmsStory, [ index ]: {} })
      formik.setFieldValue(`stories.${cmsStoryIndex}.cms_media_id`, '')
    }
    else {
      setSelectedThumbnail({})
      formik.setFieldValue('thumbnail_cms_image_id', '')
    }
  }

  const handleRemoveStory = (index) => {
    delete selectedCmsStory[index]
    var newSelectedCmsStory = Object.keys(selectedCmsStory).map((key) =>  selectedCmsStory[key])
    const cmsStory          = Object.assign({}, newSelectedCmsStory)

    setSelectedCmsStory(cmsStory)
  }

  return (
    <>
      <FormikProvider value={ formik }>
        <Form>
          <Row>
            <Col xs={ 12 } md={ 4 }>
              <FormGroup
                required={ true }
              >
                <div className='d-flex justify-content-between'>
                  <div>
                    <Label className='font-weight-bolder mr-3'>Thumbnail</Label>
                    {
                      isThumbnailSelected
                        ? (
                          <>
                            <div className='d-flex flex-column mb-1'>
                              <img width='50%' src={ selectedThumbnail.url } />
                              <div className="small">{ selectedThumbnail.file_name }</div>
                            </div>
                            <div>
                              <Button
                                className='align-self-center'
                                color='warning'
                                onClick={ handleRemoveImage }
                              >
                                <i className="fas fa-trash" />
                              </Button>
                            </div>
                          </>
                        )
                        : (
                          <Button onClick={ () => openDrawer('story_group') } >
                            { 'Select Image' }
                          </Button>
                        )
                    }
                  </div>
                  <ToggleField
                    id={ 'is_active' }
                    name={ 'is_active' }
                    label={ 'Is Active' }
                    required={ true }
                  />
                </div>
              </FormGroup>
              <InputField
                type='text'
                name='title'
                label='Title'
                placeholder='Tinkerlust'
                required={ true }
              />
              <div className='d-flex justify-content-between'>
                <InputField
                  type='date'
                  label='Start Date'
                  name='starts_at'
                  formText={ 'Tanggal mulai story group active' }
                />
                <InputField
                  label='Start Time'
                  type='time'
                  name='starts_time'
                  formText={ 'Waktu mulai story group active' }
                />
              </div>

              <div className='d-flex justify-content-between'>
                <InputField
                  type='date'
                  label='Expired Date'
                  name='expires_at'
                  formText={ 'Tanggal akhir story group active' }
                />
                <InputField
                  label='Expired Time'
                  type='time'
                  name='expires_time'
                  formText={ 'Waktu selesai story group active' }
                />
              </div>


            </Col>
            <Col xs={ 12 } md={ 8 } className='vh-100' style={{ overflowY: 'scroll' }}>
              <div className='h2'>{ 'Cms Story' }</div>
              <p>{ 'a Story for Story Group' }</p>
              <CmsStoryFieldArray
                onRemoveImage={ handleRemoveImage }
                handleRemoveStory={ handleRemoveStory }
                onClickOpenDrawer={ openDrawer }
                name={ 'stories' }
                selectedStory={ selectedCmsStory }
              />
              <div className='p-2 position-sticky fixed-bottom bg-white'>
                <Button
                  className='mt-2'
                  onClick={ formik.submitForm }
                  block={ false }
                  color='primary'
                >
                  { 'Submit' }
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </FormikProvider>
      <Drawer
        title={ 'Cms Media' }
        isOpen={ isCmsMediaDrawerOpen }
        onClickClose={ () => setIsCmsMediaDrawer(false) }
      >
        <Container>
          <CmsMediaSidebar
            pageUtils={ pageUtils }
            onClickSubmit={ (media) => handleClickCmsMediaSidebar(media) }
          />
        </Container>
      </Drawer>
    </>
  )
}

CmsStoryGroupForm.propTypes    = propTypes
CmsStoryGroupForm.defaultProps = defaultProps

export default CmsStoryGroupForm
